// extracted by mini-css-extract-plugin
export var caption = "text-module--caption--KRHF8";
export var disclaimer = "text-module--disclaimer--wSmZm";
export var lede = "text-module--lede--4k9nh";
export var root = "text-module--root--SCCxt";